export default __webpack_public_path__ + "static/media/card-leaderboard.17b9e6b1.jpg";